// Visitors' Book page (templates/page.guestbook.liquid); the board is assets/ad-vb-board.js, the tools drawn on top assets/ad-vb-tools.js. (Comments and indents stripped to fit; the commented source is _src/ad-guestbook.src.js.)
(() => {
const $ = (id) => document.getElementById(id);
if (!window.ADBoard || !$('vbCanvas')) return;
let DATA = {};
try { DATA = JSON.parse($('vbData').textContent); } catch (e) {}
const LINES = DATA.inspiration;
let deck = [], lastLine = -1;
const inspire = () => {
if (!deck.length) {
deck = LINES.map((_, i) => i);
for (let i = deck.length - 1; i > 0; i--) { const j = Math.floor(Math.random() * (i + 1)); [deck[i], deck[j]] = [deck[j], deck[i]]; }
if (deck[deck.length - 1] === lastLine) deck.unshift(deck.pop());
}
lastLine = deck.pop();
$('vbFortune').textContent = LINES[lastLine];
};
if ((window.devicePixelRatio || 1) > 1.4) { $('vbCanvas').width = 1440; $('vbCanvas').height = 960; }
const board = window.ADBoard($('vbCanvas'));
const HINTS = DATA.hints;
const pix = (rows) => {
const c = document.createElement('canvas'), x = c.getContext('2d'), i = new Image();
c.width = c.height = 16;
rows.forEach((r, y) => { for (let k = 0; k < 16; k++) if (r[k] === '#') x.fillRect(k, y, 1, 1); });
i.src = c.toDataURL(); i.alt = '';
return i;
};
DATA.palette.forEach(([c, name]) => {
const b = document.createElement('button');
b.type = 'button'; b.className = 'vbC'; b.dataset.colour = c; b.title = name; b.style.background = c;
$('vbPal').append(b);
});
const pick = (sel, on) => document.querySelectorAll(sel).forEach((b) => b.setAttribute('aria-pressed', b === on));
const wire = (sel, use) => document.querySelectorAll(sel).forEach((b, i) => b.addEventListener('click', () => { use(b, i); pick(sel, b); }));
const cvs = $('vbCanvas');
const useColour = (c) => {
board.set({ colour: c });
$('vbPick').value = c;
pick('.vbC', document.querySelector('.vbC[data-colour="' + c + '"]'));
extra.update();
};
document.querySelectorAll('.vbT').forEach((b) => b.append(pix(DATA.icons[b.dataset.tool])));
let was = 'pen', cur = 'pen', size = 12, alpha = 1;
const extra = window.ADBoardTools ? window.ADBoardTools(board, cvs, {
colour: () => board.state.colour,
size: () => size,
alpha: () => alpha,
setColour: (c) => useColour(c),
back: () => document.querySelector('.vbT[data-tool="' + was + '"]').click()
}) : { use: () => false, update() {}, finish() {} };
wire('.vbT', (b) => {
const t = b.dataset.tool;
if (!extra.use(t)) board.set({ tool: t });
if (t !== 'pick') was = t;
cur = t;
$('vbRefImg').style.cursor = t === 'pick' ? 'crosshair' : '';
$('vbHint').textContent = HINTS[t];
const fl = (board.flows || []).includes(t);
$('vbFlow').disabled = !fl;
$('vbFlowBox').classList.toggle('off', !fl);
});
wire('.vbC', (b) => useColour(b.dataset.colour));
$('vbPick').addEventListener('input', () => useColour($('vbPick').value));
const toPos = (s) => Math.round(100 * Math.sqrt((s - 1) / 99)), toSize = (v) => Math.round(1 + 99 * (v / 100) ** 2);
const setSize = (s) => {
size = s; board.set({ size }); extra.update();
$('vbSizeN').textContent = s;
pick('.vbS', document.querySelector('.vbS[data-size="' + s + '"]'));
};
document.querySelectorAll('.vbS').forEach((b) => b.addEventListener('click', () => { setSize(Number(b.dataset.size)); $('vbSize').value = toPos(size); }));
$('vbSize').addEventListener('input', () => setSize(toSize(Number($('vbSize').value))));
const slide = (id, key) => $(id).addEventListener('input', () => {
const v = Number($(id).value);
if (key === 'alpha') alpha = v / 100;
board.set({ [key]: v / 100 });
$(id + 'N').textContent = v + '%';
extra.update();
});
slide('vbAlpha', 'alpha');
slide('vbFlow', 'flow');
document.querySelector('.vbT[data-tool="pen"]').click();
document.querySelector('.vbS[data-size="12"]').click();
useColour('#000000');
cvs.parentNode.addEventListener('pointermove', (e) => {
const r = cvs.getBoundingClientRect();
$('vbXY').textContent = Math.max(0, Math.min(719, Math.floor((e.clientX - r.left) * 720 / r.width))) + ', ' + Math.max(0, Math.min(479, Math.floor((e.clientY - r.top) * 480 / r.height)));
});
cvs.parentNode.addEventListener('pointerleave', () => { $('vbXY').textContent = ''; });
$('vbUndo').addEventListener('click', () => { extra.finish(); board.undo(); });
$('vbRedo').addEventListener('click', () => board.redo());
let armed = 0;
$('vbNew').addEventListener('click', () => {
const b = $('vbNew');
if (!armed) {
b.value = 'Sure?';
armed = setTimeout(() => { b.value = 'Clear'; armed = 0; }, 3000);
return;
}
clearTimeout(armed); armed = 0; b.value = 'Clear';
board.clear();
});
const P = DATA.pictures;
const NOPE = /(^|[^a-z])(dead|death|kill|slaughter|hunt|gun|rifle|weapon|blood|carcass|wound|injur|surgery|necrops|dissect|skull|prison|nude|bomb|crash|wreck|grave|cemeter|funeral|poison|fire|oil spill|cigar|smok)/i;
const NOPE2 = /(^|[^a-z])(bar|beer|sex|trap|drug|bone|bones|tag|tagged|tagging)([^a-z]|$)/i;
const TW = (window.devicePixelRatio || 1) > 1.4 ? 960 : 500;
const API = 'https://commons.wikimedia.org/w/api.php?origin=*&format=json&action=query&generator=search&gsrnamespace=6&gsrlimit=40&prop=imageinfo&iiprop=url|size&iiurlwidth=' + TW;
const found = {}, seen = new Set();
const search = async (word) => {
const f = found[word] || (found[word] = { list: [], off: 0 });
if (f.list.length || f.off === null) return f.list;
const j = await fetch(API + '&gsroffset=' + f.off + '&gsrsearch=' + encodeURIComponent(word + ' filemime:image/jpeg ' + P.where)).then((r) => r.json());
f.off = j.continue ? j.continue.gsroffset : null;
Object.values((j.query && j.query.pages) || {}).forEach((p) => {
const ii = p.imageinfo && p.imageinfo[0];
if (!ii || !ii.thumburl || ii.width < Math.max(600, TW) || seen.has(ii.thumburl) || NOPE.test(p.title) || NOPE2.test(p.title)) return;
f.list.push({ src: ii.thumburl, alt: p.title.replace(/^File:/, '').replace(/[.][a-zA-Z]+$/, '') });
});
return f.list;
};
const loads = (src) => new Promise((ok, no) => { const i = new Image(); i.crossOrigin = 'anonymous'; i.onload = ok; i.onerror = no; i.src = src; });
const lucky = async () => {
for (let n = 0; n < 6; n++) {
try {
const list = await search(P.words[Math.floor(Math.random() * P.words.length)]);
while (list.length) {
const pic = list.splice(Math.floor(Math.random() * list.length), 1)[0];
if (seen.has(pic.src)) continue;
seen.add(pic.src);
try { await loads(pic.src); return pic; } catch (e) { /* (a picture that won't load: try the next) */ }
}
} catch (e) { /* (the search didn't answer: try another word) */ }
}
return null;
};
const ahead = [lucky(), lucky()];
let busy = false;
const im = $('vbRefImg');
im.crossOrigin = 'anonymous';
im.addEventListener('click', (e) => {
if (cur !== 'pick') return;
const r = im.getBoundingClientRect(), c = document.createElement('canvas'), g = c.getContext('2d');
c.width = c.height = 1;
try {
g.drawImage(im, Math.floor((e.clientX - r.left) * im.naturalWidth / r.width), Math.floor((e.clientY - r.top) * im.naturalHeight / r.height), 1, 1, 0, 0, 1, 1);
const d = g.getImageData(0, 0, 1, 1).data;
useColour('#' + [d[0], d[1], d[2]].map((v) => v.toString(16).padStart(2, '0')).join(''));
document.querySelector('.vbT[data-tool="' + was + '"]').click();
} catch (err) { /* (a picture that won't let its colours be read) */ }
});
const show = async () => {
if (busy) return;
busy = true;
const b = $('vbRefNext');
b.value = 'Searching...'; b.disabled = true;
const pic = await ahead.shift();
ahead.push(lucky());
if (pic) { im.src = pic.src; im.alt = im.title = pic.alt; im.hidden = false; }
inspire(); fit();
b.value = 'Inspire me'; b.disabled = false;
busy = false;
};
$('vbRefNext').addEventListener('click', show);
inspire();
const side = document.querySelector('#vb .side'), sideIn = side.firstElementChild, frame = $('vbFrame');
const tools = document.querySelector('#vb .tools'), tIn = tools.firstElementChild, tbl = document.querySelector('#vb .vbBoard');
function fit() {
const inner = tbl.clientWidth;
if (window.innerWidth <= 760) {
tools.classList.remove('small');
cvs.style.width = (inner - 14) + 'px';
side.style.width = '';
frame.style.height = Math.round(frame.offsetWidth * 0.62) + 'px';
return;
}
for (const small of [false, true]) {
tools.classList.toggle('small', small);
const left = inner - tools.offsetWidth - 20, sw = Math.max(small ? 180 : 200, Math.round(left * 0.36), left - 720);
cvs.style.width = (left - sw) + 'px';
side.style.width = sw + 'px';
if (tIn.offsetHeight <= cvs.offsetHeight) break;
}
frame.style.height = Math.max(110, Math.max(cvs.offsetHeight, tIn.offsetHeight) - (sideIn.offsetHeight - frame.offsetHeight)) + 'px';
}
window.addEventListener('resize', fit);
fit();
show();
const about = $('vbAbout');
const shut = () => { about.hidden = true; try { localStorage.setItem('vbAbout', '1'); } catch (e) {} };
const info = () => { about.hidden = false; $('vbAboutOk').focus({ preventScroll: true }); };
$('vbAboutOk').addEventListener('click', shut);
$('vbAboutX').addEventListener('click', shut);
$('vbAboutI').addEventListener('click', () => { shut(); show(); });
about.addEventListener('keydown', (e) => { if (e.key === 'Escape') shut(); });
$('vbHelp').addEventListener('click', info);
let told = false;
try { told = localStorage.getItem('vbAbout') === '1'; } catch (e) {}
if (!told) info();
const entries = [], have = new Set();
const PER = 6;
let shown = 0, more = false, asking = false, failed = false, wallT = null;
const pad = (n) => String(n).padStart(4, '0');
const day = (d) => d.getDate() + ' ' + d.toLocaleString('en-GB', { month: 'short' }) + ' ' + d.getFullYear();
const esc = (t) => String(t).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]);
const posts = $('vbPosts'), tail = $('vbPager');
const put = (x, i) => {
const td = (wallT.rows[i >> 1] || wallT.insertRow()).insertCell();
td.setAttribute('valign', 'top'); td.setAttribute('width', '170');
td.innerHTML = '<img src="' + esc(x.img) + '" width="160" height="120" loading="lazy" decoding="async" alt="Drawing in entry #' + pad(x.no) + '"><br>'
+ '<b>#' + pad(x.no) + '</b> <a href="#">' + esc(x.name || 'Anonymous') + '</a><br><font size="2">' + esc(x.when) + '</font>'
+ (x.pending ? '<br><font size="2" color="#ff0000"><b>Waiting for approval</b></font>' : '')
+ (x.msg ? '<span class="msg">' + esc(x.msg) + '</span>' : '');
};
const upTo = (n) => { n = Math.min(n, entries.length); for (; shown < n; shown++) put(entries[shown], shown); };
const status = () => {
if (!entries.length) { tail.innerHTML = ''; return; }
if (failed) tail.innerHTML = 'More entries didn’t load. <a href="#" id="vbRetry">Try again</a>';
else if (shown < entries.length || more) tail.textContent = 'Loading more entries...';
else tail.textContent = shown > PER ? 'That’s everyone on the wall so far.' : '';
};
const redraw = (n) => {
n = Math.max(n || shown, PER);
shown = 0;
if (!entries.length) { posts.innerHTML = '<p class="none">' + (asking ? 'Loading the wall...' : 'Nothing on the wall yet. Be the first to sign!') + '</p>'; status(); return; }
posts.innerHTML = '<table border="1" cellpadding="6" cellspacing="0"></table>';
wallT = posts.firstChild;
upTo(n);
status();
};
const take = (wall, top) => {
let n = 0;
wall.forEach((x, i) => {
const no = Number(x.no) || top - i;
if (have.has(no)) return;
have.add(no); n++;
entries.push({ img: x.img, no, name: x.name, when: x.when, msg: x.msg });
});
return n;
};
const near = () => tail.getBoundingClientRect().top < window.innerHeight + 900;
const older = async () => {
asking = true; status();
try {
const last = entries[entries.length - 1].no;
const d = await fetch(INBOX + (INBOX.indexOf('?') < 0 ? '?' : '&') + 'before=' + last).then((r) => r.json());
const n = take(d.wall || [], 0);
more = d.more === true && n > 0;
} catch (e) { failed = true; }
asking = false;
};
const next = async () => {
if (next.on) return;
next.on = true;
if (shown < entries.length) upTo(shown + PER);
else if (more && !failed) await older();
next.on = false;
status();
if (!failed && (shown < entries.length || more) && near()) requestAnimationFrame(next);
};
tail.addEventListener('click', (e) => {
if (e.target.id !== 'vbRetry') return;
e.preventDefault();
failed = false; next();
});
const INBOX = DATA.inbox || '';
let count = 0;
const odo = (n) => { $('vbCount').innerHTML = String(n).padStart(6, '0').replace(/[0-9]/g, '<i>$&</i>'); };
asking = !!INBOX;
redraw();
if (INBOX) {
fetch(INBOX).then((r) => r.json()).then((d) => {
const wall = d.wall || [];
count = wall.reduce((m, x) => Math.max(m, Number(x.no) || 0), Math.max(count, Number(d.count) || 0, wall.length));
odo(count);
take(wall, count);
more = d.more === true;
}).catch(() => {}).then(() => { asking = false; redraw(); if (near()) next(); });
}
if ('IntersectionObserver' in window) new IntersectionObserver((es) => { if (es[0].isIntersecting) next(); }, { rootMargin: '0px 0px 900px 0px' }).observe(tail);
else window.addEventListener('scroll', () => { if (near()) next(); }, { passive: true });
const form = $('vbSign');
const jpeg = () => {
const c = document.createElement('canvas');
c.width = 1080; c.height = 720;
board.flush();
c.getContext('2d').drawImage(cvs, 0, 0, c.width, c.height);
return c.toDataURL('image/jpeg', 0.86);
};
const newsletter = (email) => {
const f = new FormData();
f.append('form_type', 'customer');
f.append('utf8', '✓');
f.append('contact[email]', email);
f.append('contact[tags]', 'newsletter, visitors-book');
fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'contact', { method: 'POST', body: f }).catch(() => {});
};
const SORRY = {
email: 'Please check your e-mail address.',
full: 'The book is very full today. Please come back tomorrow!',
busy: 'Lots of people are signing right now. Please try again in a minute.'
};
let sending = false;
form.addEventListener('submit', async (e) => {
e.preventDefault();
extra.finish();
if (sending) return;
const err = $('vbError'), btn = form.querySelector('[type="submit"]');
const email = $('vbEmail').value.trim();
if (!/^[^ @]+@[^ @]+[.][^ @]+$/.test(email)) { err.textContent = 'Please enter your e-mail so we can tell you if your drawing goes on the wall.'; $('vbEmail').focus(); return; }
if (board.blank()) { err.textContent = 'The board is empty. Draw something first, anything counts!'; return; }
if (!INBOX) { err.textContent = 'The book isn’t open for signing yet. Come back soon!'; return; }
const name = $('vbName').value.trim(), message = $('vbMsg').value.trim();
const showDrawing = $('vbShow').checked, showMessage = $('vbMsgShow').checked, news = $('vbNews').checked;
const image = jpeg();
let no = 0;
sending = true; err.textContent = ''; btn.disabled = true; btn.value = 'Sending...';
try {
const r = await fetch(INBOX, { method: 'POST', headers: { 'Content-Type': 'text/plain;charset=utf-8' }, body: JSON.stringify({ name, email, message, showDrawing, showMessage, newsletter: news, image, website: $('vbWeb').value }) });
const d = await r.json();
if (!d.ok) throw new Error(d.error || 'no');
no = Number(d.no) || 0;
} catch (x) {
sending = false; btn.disabled = false; btn.value = 'Sign the Guestbook';
err.textContent = SORRY[x.message] || 'Sorry, that didn’t go through. Please try again in a moment.';
return;
}
if (news) newsletter(email);
count = no ? Math.max(count, no) : count + 1;
no = no || count;
odo(count);
if (showDrawing) {
entries.unshift({ img: image, no, name, when: day(new Date()), msg: showMessage ? message : '', pending: true });
have.add(no);
redraw(shown + 1);
}
form.innerHTML = '<p><b>Thanks for signing! You are entry #' + pad(no) + '.</b><br>Your drawing is with the webmaster. '
+ (showDrawing ? 'If it goes on the wall, we’ll e-mail you.' : 'It stays between us.') + '</p>';
board.clear();
$('vbPosts').scrollIntoView({ behavior: 'smooth', block: 'start' });
});
})();